module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('home-help-navi')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('home-help-content')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce326f80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/help/HomeHelp.vue
// module id = 172
// module chunks = 1